import React from 'react';
import PropTypes from 'prop-types';
import GetTheAppLinks from '~/constants/GetTheAppLinks';
import logEvent from '~/util/analytics';
import Styled from '../Styled/Styled';

import css from './TodaysAlertsTooltip.scss';

const handleClick = () => {
  logEvent('conversion', {
    type: 'todays_alerts_tooltip',
    campaign: 'thescoreapp',
  });
};

class TodaysAlertsTooltip extends React.PureComponent {
  render() {
    const getTheAppLink = this.props.leagueSlug
      ? `${GetTheAppLinks.todays_alerts_base}${this.props.leagueSlug.toUpperCase()}Events`
      : '';
    return (
      <div className={css.toolTipContainer}>
        <div className={css.toolTipImage} />
        <div
          className={css.closeButton}
          onClick={() => this.props.closeClick()}
          role="button"
          tabIndex={0}
        />
        <div className={css.copyBox}>
          <div className={css.header}>Real Time Alerts</div>
          <div className={css.smallCopyBox}>
            It&#39;s all in the app! Personalized news, scores, stats for all your favorite leagues.
          </div>
          <a href={getTheAppLink} className={css.getTheAppButtonWrap}>
            <button className={css.getTheAppButton} onClick={handleClick}>
              Get the app
            </button>
          </a>
        </div>
        <div className={css.toolTipArrow} />
      </div>
    );
  }
}

TodaysAlertsTooltip.propTypes = {
  closeClick: PropTypes.func.isRequired,
  leagueSlug: PropTypes.string,
};

TodaysAlertsTooltip.defaultProps = {
  leagueSlug: null,
};

TodaysAlertsTooltip.displayName = 'TodaysAlertsTooltip';

export default Styled(TodaysAlertsTooltip, [css]);
